import { API_BASE_URL, authFetchJson } from '../apiClient.ts';

export type MemberRole = 'ADMIN' | 'USER';

// Invited until the first sign-in, revoked once an admin turns the login off.
export type MemberStatus = 'active' | 'invited' | 'revoked';

export type TeamMember = {
  id: number;
  fullName: string;
  email: string;
  role: MemberRole;
  status: MemberStatus;
  lastLoginAt: string | null;
  lastSeenAt: string | null;
  createdAt: string;
};

export type InviteInput = { fullName: string; email: string; role: MemberRole };
export type MemberChange = { role?: MemberRole; active?: boolean };

// The same actions from Settings (the signed-in admin's workspace) and from
// Platform (any workspace). Only the addresses differ.
export type TeamActions = {
  invite: (input: InviteInput) => Promise<{ member: TeamMember; emailed: boolean }>;
  sendPasswordLink: (memberId: number) => Promise<void>;
  update: (memberId: number, change: MemberChange) => Promise<TeamMember>;
};

const teamActions = (base: string, memberBase: string): TeamActions => ({
  invite: async (input) =>
    (await authFetchJson(`${base}/invite`, { method: 'POST', body: JSON.stringify(input) }))
      .json as { member: TeamMember; emailed: boolean },
  sendPasswordLink: async (memberId) => {
    await authFetchJson(`${memberBase}/${memberId}/password-link`, { method: 'POST' });
  },
  update: async (memberId, change) =>
    (
      await authFetchJson(`${memberBase}/${memberId}`, {
        method: 'PATCH',
        body: JSON.stringify(change)
      })
    ).json as TeamMember
});

export const fetchTeam = async () =>
  (await authFetchJson(`${API_BASE_URL}/team`)).json as TeamMember[];

export const workspaceTeam = teamActions(`${API_BASE_URL}/team`, `${API_BASE_URL}/team`);

export const platformTeam = (tenantId: number) => {
  const base = `${API_BASE_URL}/platform/tenants/${tenantId}`;
  return teamActions(base, `${base}/users`);
};
